import React from 'react';
import hasRole from 'util/hasRole';
import NotFound404 from 'components/NotFound404';
import Error from 'components/Error';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from 'rebass';
import ErrorBoundary from 'components/ErrorBoundary';
import { uploadRequest } from '../../ducks/dataImport';
import { bindActionCreators } from 'redux';
import DataImportUpload from './DataImportUpload';

class DataImport extends React.Component {

  render() {

    const { loggedUser, uploadingError, onUpload } = this.props;
    const isAllowed = hasRole(loggedUser, ['KULTU_ADMIN', 'KULTU_SEURANTA_ADMIN']);
    if (isAllowed) {
      return (
        <Container
          mb={[8, 8, 7]}
          textAlign='center'>
          <ErrorBoundary>
            {uploadingError && <Error message={uploadingError} />}
            <DataImportUpload uploadFn={onUpload} />
          </ErrorBoundary>
        </Container>
      )
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />
    }
  }
}

DataImport.propTypes = {
  loggedUser: PropTypes.object,
  loadingError: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    loggedUser: state.userState.user,
    uploadingError: state.dataImport.uploadingError,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onUpload: (file) => {
    return uploadRequest(file);
  }
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DataImport)



// WEBPACK FOOTER //
// ./src/containers/dataImport/index.js